exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".loading-text[data-v-5ef2a507]{background-size:200% auto;animation:slide-5ef2a507 1.5s linear infinite;will-change:background-position}@keyframes slide-5ef2a507{to{background-position:-200% center}}\n", ""]);

